// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"fc037e79","55":"6b3b1193","453":"231297bf","580":"f953558a","604":"7abb461a","633":"d69a62d5","780":"85396ec3","782":"670e4645","854":"4d3fa126","982":"8102a159"}[chunkId] + ".chunk.js";
};